import React, { useEffect, useState, useCallback } from 'react';
import Box from '@mui/material/Box';
import Tabs, { tabsClasses } from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import { useSelector } from 'react-redux';
import { categoryUrl } from '../../../shared/extra';
import { useLocation, useNavigate } from 'react-router-dom';

const getSingleCategory = (rawCategory) => {
  if (!rawCategory || typeof rawCategory !== 'string') return '';

  return rawCategory
    .split('?')[0]
    .split('&')[0]
    .trim()
    .split(/[+, ]+/)[0] || ''; // ✅ ONLY FIRST
};

function MobileProductCategoryTabs() {
  const [value, setValue] = useState(0);
  const coreCategoryData = useSelector((state) => state.Category.allData);
  const categoryData = coreCategoryData?.filter((item) => item?.products?.length > 0);
  const navigate = useNavigate();
  const location = useLocation();

  const searchParams = new URLSearchParams(location.search);
  const categoryParam = searchParams.get('category');

  useEffect(() => {
    const selectedCategory = getSingleCategory(categoryParam);

    if (!selectedCategory) return;

    const selectedIndex = categoryData.findIndex(
      (item) =>
        categoryUrl(item.title)?.toLowerCase() ===
        selectedCategory.toLowerCase()
    );

    if (selectedIndex !== -1 && selectedIndex !== value) {
      setValue(selectedIndex);
    }
  }, [categoryParam, categoryData, value]);


  const handleChange = useCallback(
    (event, newValue) => {
      setValue(newValue);

      const selectedCategory = categoryData[newValue]?.title;
      const categorySlug = categoryUrl(selectedCategory);

      // ✅ Create CLEAN params (no utm, no multi)
      const params = new URLSearchParams();
      params.set('category', categorySlug);

      navigate(`${location.pathname}?${params.toString()}`);
    },
    [categoryData, navigate, location.pathname]
  );

  return (
    <Box
      sx={{
        flexGrow: 1,
        maxWidth: 'false',
        bgcolor: 'background.paper',
      }}
    >
      <Tabs
        value={value}
        onChange={handleChange}
        variant="scrollable"
        scrollButtons="auto"
        allowScrollButtonsMobile
        aria-label="visible arrows tabs example"
        sx={{
          [`& .${tabsClasses.scrollButtons}`]: {
            '&.Mui-disabled': { opacity: 0.3 },
          },
        }}
      >
        {categoryData?.map((item) => {
          if (item?.products?.length > 0) {
            return (
              <Tab
                key={`${item?.title}-category`}
                label={`${item?.title}`}
                sx={{
                  color: 'primary.main',
                  textTransform: 'capitalize',
                  fontSize: '13.5px',
                  fontWeight: 400,
                }}
              />
            );
          } else {
            return null;
          }
        })}
      </Tabs>
    </Box>
  );
}

export default MobileProductCategoryTabs;
